import {QTable} from 'quasar'
import ColumnSelection from './table-column-selection'
import TableHeader from './table-header.js'

const HTable = {
  name: 'HTable',
  extends: QTable,
  mixins: [
    ColumnSelection,
    TableHeader
  ],
  mounted () {

  },
  methods: {

  }
};

export default HTable;


// WEBPACK FOOTER //
// ./resources/assets/js/components/HTable/HTable.js